import { apiCall } from './gqlClient';

const CIRCUITEXERCISEALTERNATIVES_QUERY = `
  query circuitExerciseAlternatives($circuitExerciseId: String!, $equipmentContext: String) {
    circuitExerciseAlternatives(circuitExerciseId: $circuitExerciseId, equipmentContext: $equipmentContext)
    {
      id
			circuitExerciseId
			exerciseId
			difficulty
			orderPreference
			notes
      ...fragments
    }
  }`;

export const circuitExerciseAlternativesApiCall = async ({circuitExerciseId, equipmentContext}, fragments = null) => apiCall({ query: CIRCUITEXERCISEALTERNATIVES_QUERY, variables: {circuitExerciseId, equipmentContext}, fragments });

const CREATECIRCUITEXERCISEALTERNATIVE_QUERY = `
  mutation createCircuitExerciseAlternative($input: CircuitExerciseAlternativeInput!) {
    createCircuitExerciseAlternative(input: $input)
    {
      id
			circuitExerciseId
			exerciseId
			difficulty
			orderPreference
			notes
      ...fragments
    }
  }`;

export const createCircuitExerciseAlternativeApiCall = async ({input}, fragments = null) => apiCall({ query: CREATECIRCUITEXERCISEALTERNATIVE_QUERY, variables: {input}, fragments });

const UPDATECIRCUITEXERCISEALTERNATIVE_QUERY = `
  mutation updateCircuitExerciseAlternative($id: String!, $input: CircuitExerciseAlternativeInput!) {
    updateCircuitExerciseAlternative(id: $id, input: $input)
    {
      id
			circuitExerciseId
			exerciseId
			difficulty
			orderPreference
			notes
      ...fragments
    }
  }`;

export const updateCircuitExerciseAlternativeApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATECIRCUITEXERCISEALTERNATIVE_QUERY, variables: {id, input}, fragments });

const DELETECIRCUITEXERCISEALTERNATIVE_QUERY = `
  mutation deleteCircuitExerciseAlternative($id: String!) {
    deleteCircuitExerciseAlternative(id: $id)
    {
      id
			circuitExerciseId
			exerciseId
			difficulty
			orderPreference
			notes
      ...fragments
    }
  }`;

export const deleteCircuitExerciseAlternativeApiCall = async ({id}, fragments = null) => apiCall({ query: DELETECIRCUITEXERCISEALTERNATIVE_QUERY, variables: {id}, fragments });
